import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IFile {
  id: number;
  name: string;
  url: string;
  purpose: string;
  createdAt?: string;
}

export interface IUploadFileRequest {
  name: string;
  content: string;
}

export interface IUploadFileResponse {
  url: string;
  id: number;
}

export interface IImage {
  imageContent: string;
}

export const getFiles = async (
  abortController: AbortController,
  purpose: string,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IFile>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/files?purpose=${purpose}&pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getImage = async (
  abortController: AbortController,
  imageUrl: string,
  container?: string
): Promise<IImage> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/image?imageUrl=${imageUrl}${
      container ? `&container=${container}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const uploadFile = async (
  abortController: AbortController,
  name: string,
  content: string
): Promise<IUploadFileResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/file?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'POST',
    abortController,
    JSON.stringify({
      name: name,
      content: content,
    })
  );
};

export const uploadImage = async (
  abortController: AbortController,
  name: string,
  purpose: string,
  content: ArrayBuffer
): Promise<IUploadFileResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/image?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'POST',
    abortController,
    JSON.stringify({
      name: name,
      purpose: purpose,
      content: content,
    })
  );
};

export const getLogFile = async (
  abortController: AbortController,
  path: string
): Promise<Response> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/file?filePath=${path}`,
    'GET',
    abortController,
    undefined,
    true
  );
};
